module.exports = __webpack_public_path__ + "img/sfondo-verde-gradiente.b4ba5020.png";